import React, { Fragment } from "react";
import blogs from "../../api/blogs";
import { useParams, Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import NavbarS4 from "../../components/NavbarS4/NavbarS4";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo2.png";


import gl1 from "../../images/blog-details/img-1.jpg";
import gl2 from "../../images/blog-details/img-2.jpg";
import BlogSidebar from "../../components/BlogSidebar/BlogSidebar";
import SEO from "../../components/Seo";

const BlogDetails = () => {
    const { slug } = useParams();
    const Details = blogs.find((item) => item.slug === slug);

    if (!Details) {
        return <div>Blog not found</div>;
    }

    return (
        <Fragment>
            <SEO
                title={Details.metaTitle || Details.title}
                description={Details.metaDescription}
                keywords={Details.keyword}
                image={Details.blogSingleImg}
            />
            <NavbarS4
                hclass={"wpo-site-header wpo-header-style-s11"}
                Logo={Logo}
                col1={"col-lg-3 col-md-3 col-3 d-lg-none dl-block"}
                col2={"col-lg-2 col-md-4 col-6"}
                col3={"col-lg-7 col-md-1 col-1"}
                col4={"col-lg-3 col-md-4 col-2"}
            />

            <PageTitle pageTitle={Details.title} pagesub={"Blog Details"} />

            <section className="wpo-blog-single-section section-padding pt-0">
                <div className="container-fluid">
                    <div className="wpo-blog-wraper">
                        <div className="wpo-blog-content">
                            <div
                                className="post format-standard-image scroll-text-animation"
                                data-animation="fade_from_bottom"
                            >
                                <div className="entry-media">
                                    <img src={Details.blogSingleImg} alt="" />
                                </div>

                                <div className="entry-meta">
                                    <ul>
                                        <li>
                                            By:<Link to="/blog"> {Details.author}</Link>
                                        </li>
                                        <li>Date: {Details.create_at}</li>
                                    </ul>
                                </div>

                                {/* ✅ Dynamic Blog Content */}
                                <div className="entry-content">
                                    {Details.content.split("\n").map((line, index) => {
                                        const trimmed = line.trim();

                                        if (!trimmed) return null;

                                        // If line looks like heading (no period at end and short length)
                                        if (
                                            trimmed.length < 80 &&
                                            !trimmed.endsWith(".") &&
                                            !trimmed.match(/^\d+\./)
                                        ) {
                                            return <h2 key={index}>{trimmed}</h2>;
                                        }

                                        // Numbered headings (FAQs)
                                        if (trimmed.match(/^\d+\./)) {
                                            return <h3 key={index}>{trimmed}</h3>;
                                        }

                                        return <p key={index}>{trimmed}</p>;
                                    })}
                                </div>


                                {/* Gallery Section */}
                                <div
                                    className="gallery scroll-text-animation"
                                    data-animation="fade_from_bottom"
                                >
                                    <div>
                                        <img src={gl1} alt="" />
                                    </div>
                                    <div>
                                        <img src={gl2} alt="" />
                                    </div>
                                </div>
                            </div>

                            {/* Share & Tags */}
                            <div
                                className="tag-wrap scroll-text-animation"
                                data-animation="fade_from_bottom"
                            >
                                <div className="tag-share-s2">
                                    <div className="tag">
                                        <span>Share Article: </span>
                                        <ul>
                                            <li>
                                                <Link to="/blog">
                                                    <i className="ti-facebook"></i>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/blog">
                                                    <i className="ti-twitter-alt"></i>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/blog">
                                                    <i className="ti-linkedin"></i>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/blog">
                                                    <i className="ti-instagram"></i>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="tag-share">
                                    <div className="tag">
                                        <span>Tags:</span>
                                        <ul>
                                            <li>
                                                <Link to="/blog">Real Estate</Link>
                                            </li>
                                            <li>
                                                <Link to="/blog">Ahmedabad</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Comments Section */}
                            {/* <div
                                className="comments-area scroll-text-animation"
                                data-animation="fade_from_bottom"
                            >
                                <div className="comments-section">
                                    <h3 className="comments-title">Comments:</h3>
                                    <ol className="comments">
                                        <li className="comment">
                                            <div>
                                                <div className="comment-theme">
                                                    <div className="comment-image">
                                                        <img src={blog1} alt="" />
                                                    </div>
                                                </div>
                                                <div className="comment-main-area">
                                                    <div className="comment-wrapper">
                                                        <div className="comments-meta">
                                                            <h4>Kristin Watson</h4>
                                                            <span className="comments-date">
                                                                Founder Of Megan
                                                            </span>
                                                        </div>
                                                        <div className="comment-area">
                                                            <p>
                                                                Very informative blog. It really helped me
                                                                understand real estate decisions clearly.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ol>
                                </div>

                                <div className="comment-respond">
                                    <h3 className="comment-reply-title">Leave a comment:</h3>
                                    <CommentForm />
                                </div>
                            </div> */}
                        </div>

                        <BlogSidebar blogs={blogs} />
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default BlogDetails;
